export default function () {
  var currentPagePk = $('#user_uid_js').val();
  var currentUserId = $('#data_sessionId_js').val();
  var currentJaloSessionId = $('#page_pk_id_js').val();

  if (parent.notifyIframeAboutUrlChanage) {
    parent.notifyIframeAboutUrlChanage(window.location.href, currentPagePk, currentUserId, currentJaloSessionId);
  }
}
